export default "__VITE_ASSET__f4f8b61c__"